<template>
  <div>
    <div style="padding: 10px" v-show="folderDepthList.length>0">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <a @click="queryByPid(0)">{{$t('moduleTitles.root')}}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item,index) in folderDepthList" :key="index">
          <a @click="queryByPid(item.id)">{{item.name}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoadMore" :immediate-check="false">
        <van-checkbox-group ref="checkboxGroup" v-model="selectedRowKeys">
          <div class="material-wrapper" v-for="material in materialList" :key="material.id">
            <div class="info-wrapper">
              <div
                class="left-wrapper"
                v-if="material.dir_id == undefined"
                @click="toFolder(material.id)"
              >
                <div>
                  <img style="width: 40px; height: 40px" src="@/assets/img/fold.png" />
                </div>
                <div class="material-info">
                  <div class="info-title">{{material.name}}</div>
                </div>
              </div>
              <div class="left-wrapper" v-else @click="previewPano(material)">
                <div>
                  <img style="width: 40px; height: 40px" :src="material.thumb_path" />
                </div>
                <div class="material-info">
                  <div class="info-title">{{material.filename}}</div>
                  <div class="info-description">{{material.create_time+" "+material.filesize }}</div>
                </div>
              </div>
              <div class="right-wrapper">
                <van-checkbox class="checkboxes" :name="material.id" :icon-size="16" />
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </van-pull-refresh>
    <batch-operate :selected-keys="selectedRowKeys" @close="onBatchClose" @all="onBatchAll">
      <batch-operate-item :text="$t('actionTitles.delete')" @click="batchDelete">
        <template v-slot:icon>
          <a-icon type="delete" />
        </template>
      </batch-operate-item>
      <batch-operate-item :text="$t('actionTitles.rename')" @click="onRenameClick" :disabled="selectedRowKeys.length>1">
        <template v-slot:icon>
          <a-icon type="edit" />
        </template>
      </batch-operate-item>
      <batch-operate-item :text="$t('actionTitles.moveTo')" @click="batchMove">
        <template v-slot:icon>
          <a-icon type="retweet" />
        </template>
      </batch-operate-item>
    </batch-operate>
    <!-- 樹狀彈窗-->
    <a-modal
      v-model="treeVisible"
      :title="$t('actionTitles.moveTo')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="moveTo"
      keyboard
    >
      <a-directory-tree
        :replaceFields="{children:'children', title:'name', key:'id'}"
        :load-data="onLoadData"
        :loadedKeys="loadedKeys"
        :tree-data="treeData"
        :selectedKeys="selectedKeys"
        @select="onSelect"
        ref="tree"
      />
    </a-modal>

    <!--重命名-->
    <a-modal v-model="renameVisible" :title="$t('actionTitles.rename')" :destroyOnClose="true" @ok="onRenameConfirm">
      <div>
        <div>
          <a-input v-if="renameObj.name" v-model="renameObj.name" :addonBefore="$t('edit.name')"></a-input>
          <a-input v-if="renameObj.filename" v-model="renameObj.filename" :addonBefore="$t('edit.name')"></a-input>
        </div>
      </div>
    </a-modal>

    <!-- 預覽全景 -->
    <a-modal v-model="previewVisible" :title="$t('actionTitles.preview')" centered :footer="null" class="preview-modal">
      <img :src="previewUrl"/>
    </a-modal>
  </div>
</template>
<style>
  .preview-modal .ant-modal-body{
    padding: 15px;
  }
</style>
<style lang="less" scoped>
.content-container {
  background-color: #fff;
  min-height: 100vh;
}

.material-wrapper {
  padding: 0px 10px 0px 10px;
  width: 100vw;
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: space-between;
  //   align-items: center;

  .info-wrapper {
    padding: 10px 0px 10px 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid #efeeee;
    .left-wrapper {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      overflow: hidden;
    }
    .right-wrapper {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .checkboxes{
        width: 40px;
        height: 40px;
        justify-content: center;
      }
    }
    .material-info {
      margin-left: 10px;
    }
    .info-title {
      font-size: 1rem;
      color: rgba(0, 0, 0, 1);
      font-weight: 100;
    }
    .info-description {
      font-size: 0.8rem;
      color: gray;
    }
  }
}
  .preview-modal{
    img{
      width: 100%;
    }
  }
</style>

<script>
import Vue from "vue";
import {
  Cell,
  CellGroup,
  List,
  PullRefresh,
  Search,
  Button,
  NavBar,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Icon,
} from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(List);
Vue.use(Search);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(CheckboxGroup);

import "../../../../../assets/css/mobile.less";
import { mapGetters } from "vuex";
import BatchOperate from "../../../../components/BatchOperate";
import BatchOperateItem from "../../../../components/BatchOperateItem";
import DragUploader from "@/components/DragUploader";

import {
  getMaterialList,
  delMaterial,
  rename,
  createFolder,
  getTreeDir,
  getFolderDepth,
  moveDir,
  uploadMaterial,
  materialCategorysList,
} from "@/api/material";

export default {
  components: { BatchOperate, BatchOperateItem, DragUploader },
  props: {
    type: {
      type: Number,
      require: true,
    },
    searchKey: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    searchKey(value) {
      this.searchForm.name = value;
    },
  },
  data() {
    return {
      searchForm: {
        pid: 0,
        name: this.searchKey,
        order: { create_time: "desc" },
      },
      refreshing: false,
      loading: false,
      finished: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      searchParam: {},
      materialList: [],
      selectedRowKeys: [],
      folderDepthList: [],
      treeVisible: false,
      loadedKeys: [],
      treeData: [{ id: 0, name: this.$t("moduleTitles.root") }],
      selectedKeys: [],
      selectDirIds: [],
      renameVisible: false,
      renameObj: {},
      newName: "",
      upModelVisible: false,
      previewVisible:false,
      previewUrl:''
    };
  },
  created() {},
  mounted() {
    // this.onRefresh();
  },
  methods: {
    previewPano(data){
      this.previewVisible = true
      this.previewUrl = data.location
    },
    getKey(item) {
      if (item.dir_id == undefined) {
        return "dir" + item.id;
      } else {
        return item.id + "";
      }
    },
    getId(key) {
      return key.replace("dir", "");
    },
    onRefresh() {
      this.selectedRowKeys = [];
      this.pagination.current = 1;
      this.finished = false;
      this.refreshing = true;
      this.loading = true;
      this.loadData();
      getFolderDepth({ id: this.searchForm.pid }).then((res) => {
        if (res.code === 1) {
          this.folderDepthList = res.data;
        }
      });
    },
    onLoadMore() {
      this.pagination.current += 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{ current_page: this.pagination.current, per_page: 10 },
      };

      getMaterialList(this.searchParam)
        .then((ret) => {
          this.loading = false;
          let data = ret.data.records.map((item) => {
            item.id = this.getKey(item);
            return item;
          });
          if (this.refreshing) {
            this.materialList = data;
          } else {
            this.materialList = [...this.materialList, ...data];
          }
          this.refreshing = false;

          if (data.length < this.pagination.pageSize) {
            this.finished = true;
          }
          this.pagination.total = ret.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onBatchClose() {
      this.selectedRowKeys = [];
    },
    onBatchAll() {
      if(this.selectedRowKeys.length<this.materialList.length){
        this.$refs.checkboxGroup.toggleAll(true);
      }else{
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    batchDelete() {
      let delArr = [];
      this.selectedRowKeys.forEach((key) => {
        let delInfo = { id: this.getId(key) };
        if (key.indexOf("dir") > -1) {
          delInfo.type = "dir";
        } else {
          delInfo.type = "material";
        }
        delArr.push(delInfo);
      });
      this.softDelete(delArr);
    },
    softDelete(options) {
      delMaterial(options)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.onRefresh();
            });
          }
        })
        .catch(() => {});
    },
    toFolder(key) {
      this.searchForm.pid = this.getId(key);
      //type
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    queryByPid(pid) {
      this.searchForm.pid = pid;
      this.pagination.current_page = 1;
      this.onRefresh();
    },
    batchMove() {
      this.selectDirIds = [];
      this.selectedRowKeys.map((key) => {
        if (key.indexOf("dir")) {
          this.selectDirIds.push(this.getId(key));
        }
      });

      this.treeVisible = true;
      this.treeData = [{ id: 0, name: this.$t("moduleTitles.root") }];
      this.loadedKeys = [];
    },
    onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }
        setTimeout(() => {
          getTreeDir({ pid: treeNode.dataRef.id }).then((res) => {
            if (res.code && res.data.length) {
              treeNode.dataRef.children = res.data.filter((item) => {
                if (!this.selectDirIds.includes(item.id)) {
                  return item;
                }
              });
            } else {
              treeNode.dataRef.isLeaf = true;
            }
            this.treeData = [...this.treeData];
            resolve();
          });
        }, 1);
      });
    },
    onSelect(selectedKeys, info) {
      this.selectedKeys = selectedKeys;
    },
    moveTo() {
      if (!this.selectedKeys.length) {
        this.$message.warning(this.$t("message.moveSelectHint"));
        return;
      }
      let dir = [];
      let pano = [];
      this.selectedRowKeys.forEach((key) => {
        if (key.indexOf("dir") > -1) {
          dir.push(this.getId(key));
        } else {
          pano.push(this.getId(key));
        }
      });

      let param = { to: this.selectedKeys[0], dir, pano };
      moveDir(param).then(() => {
        this.$message.success(this.$t("message.moveSuccess"));
        this.treeVisible = false;
        this.onRefresh();
      });
    },
    onRenameClick() {
      this.newName = "";
      let key = this.selectedRowKeys[0];
      this.renameObj = this.materialList.find((p) => {
        return p.id == key;
      });
      this.renameVisible = true;
    },
    onRenameConfirm() {
      if (this.renameObj.id) {
        const data = {
          id: this.getId(this.renameObj.id),
          name:
            typeof this.renameObj.dir_id === "number"
              ? this.renameObj.filename
              : this.renameObj.name,
          table_type:
            typeof this.renameObj.dir_id === "number" ? "pano" : "dir",
        };
        rename(data)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success(this.$t("message.updateSuccess"));
              this.renameVisible = false;
              this.onRefresh();
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

